import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { CANCEL_ORDER } from '../../containers/OrderHelpTemplateContainer/templateTypes';

import ModalFooter from '../ModalFooter';

/**
 * A generic dynamic actions template to render a red-coloured button that cancels an order.
 */
function OrderHelpTemplateCancelOrder({
  actionId,
  data: { buttonText },
  iframe,
  hideFooterPrevious,
  requestInteraction,
}) {
  const onSubmit = () => {
    requestInteraction({
      parentActionId: actionId,
      parentActionTemplate: CANCEL_ORDER,
      templateData: {},
    });
  };

  return (
    <Fragment>
      <ModalFooter
        buttonType="destructive"
        modal={iframe}
        onSubmit={onSubmit}
        cta={buttonText}
        hidePrevious={hideFooterPrevious}
      />
    </Fragment>
  );
}

OrderHelpTemplateCancelOrder.propTypes = {
  /**
   * Which help screen the template is currently on.
   */
  actionId: PropTypes.string.isRequired,
  /**
   * Whether to style the template appropriately for a modal.
   */
  iframe: PropTypes.bool.isRequired,
  /**
   * Whether to hide the previous button for the footer
   */
  hideFooterPrevious: PropTypes.bool,
  /**
   * The dispatch action that will be triggered onClick for each OrderHelpActionRows.
   * This will be used to update the dynamic action and grab the next self help page
   */
  requestInteraction: PropTypes.func.isRequired,
  /**
   * Data object for the template which comes from dynamic actions
   */
  data: PropTypes.shape({
    buttonText: PropTypes.string,
  }),
};

OrderHelpTemplateCancelOrder.defaultProps = {
  data: {},
  hideFooterPrevious: true,
};

export default OrderHelpTemplateCancelOrder;
